import { createAction, props } from '@ngrx/store'
import { LoginInput, LoginOutput, SignupInput, UpdateMeInput, UpdatePartnerInput } from '@papi/interfaces'
import { AuthUser } from './auth.service'

export const autologin = createAction('[Auth] Autologin')

// TODO: export from partner-api
export enum USER_LOGIN_REASONS {
  NOT_FOUND = 'not found',
  NOT_ACTIVE = 'not active',
  WRONG_PASSWORD = 'wrong password',
}

export enum RESET_PASSWORD_REASONS {
  USER_NOT_FOUND = 'user not found',
  PASSWORD_TOKEN_EXPIRED = 'password token expired',
  PASSWORDS_MISMATCH = 'passwords mismatch',
}

export const signup = createAction('[Auth] Signup', props<{ credentials: SignupInput }>())
export const signupSuccess = createAction('[Auth] Signup Success')
export const signupFailure = createAction('[Auth] Signup Failure', props<{ error: Error }>())
export const login = createAction('[Auth] Login', props<{ credentials: LoginInput }>())
export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ output: LoginOutput<AuthUser>; interactive: boolean }>()
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loginFailure = createAction('[Auth] Login Failure', props<{ reason?: USER_LOGIN_REASONS; error?: any }>())
export const logout = createAction('[Auth] Logout')

export const updateSettings = createAction(
  '[Auth] Update Settings',
  props<{ me: UpdateMeInput; partner?: UpdatePartnerInput }>()
)
export const updateSettingsSuccess = createAction('[Auth] Update Settings Success')
export const updateSettingsFailure = createAction('[Auth] Update Settings Failure', props<{ error: Error }>())
